"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPaginationParams = void 0;

var _long = _interopRequireDefault(require("long"));

var setPaginationParams = function setPaginationParams(options, pagination) {
  if (!pagination) {
    return options;
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.countTotal) !== "undefined") {
    options.params['pagination.count_total'] = pagination.countTotal;
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.key) !== "undefined") {
    // String to Uint8Array
    // let uint8arr = new Uint8Array(Buffer.from(data,'base64')); 
    // Uint8Array to String
    options.params['pagination.key'] = Buffer.from(pagination.key).toString('base64');
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.offset) !== "undefined") {
    options.params['pagination.limit'] = _long["default"].toString(pagination.limit);
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.limit) !== "undefined") {
    options.params['pagination.offset'] = _long["default"].toString(pagination.offset);
  }

  if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.reverse) !== "undefined") {
    options.params['pagination.reverse'] = pagination.reverse;
  }

  return options;
};

exports.setPaginationParams = setPaginationParams;